import {mapState} from 'vuex'

export default {
    name: 'Header',
    computed: {
        ...mapState({
            cartItemsLength: state => state.cart.items.length,
            user: state => state.account.user
        }),
    }
}